import { create } from "zustand";
import type { AuthSession, Organization, User, Workspace } from "@korin/core";

export type AuthStatus = "idle" | "loading" | "authenticated" | "anonymous";

interface AuthState {
  status: AuthStatus;
  user: User | null;
  org: Organization | null;
  accessToken: string | null;
  expiresAt: string | null;
  orgs: AuthSession["orgs"];
  workspaces: NonNullable<AuthSession["workspaces"]>;
  activeWorkspace: Workspace | null;
  setStatus: (status: AuthStatus) => void;
  setSession: (session: AuthSession) => void;
  setUser: (user: User) => void;
  setOrg: (org: Organization) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  status: "idle",
  user: null,
  org: null,
  accessToken: null,
  expiresAt: null,
  orgs: [],
  workspaces: [],
  activeWorkspace: null,
  setStatus: (status) => set({ status }),
  setSession: (session) =>
    set({
      status: "authenticated",
      user: session.user,
      org: session.org,
      accessToken: session.accessToken,
      expiresAt: session.expiresAt,
      orgs: session.orgs,
      workspaces: session.workspaces ?? [],
      activeWorkspace: session.activeWorkspace ?? null,
    }),
  setUser: (user) => set({ user }),
  setOrg: (org) => set({ org }),
  clear: () =>
    set({
      status: "anonymous",
      user: null,
      org: null,
      accessToken: null,
      expiresAt: null,
      orgs: [],
      workspaces: [],
      activeWorkspace: null,
    }),
}));
